import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/lib/Button';

import Link from '../Link';
import Loader from '../Loader';
import Avatar from '../Avatar';

import messages from '../../locale/messages';

import { EditIcon, ItineraryIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';
import noListImage from '/public/SiteImages/noReviewImage.svg';

import s from './Reviews.css';
import bt from '../../components/commonStyle.css';

const WriteReviews = ({ data, loadMoreListing, isListLoading }) => {
	const { loading, pendingReviews } = data || {};
	const intl = useIntl();
	const userId = useSelector((state) => state.account?.data?.userId);

	const showLoadMore = pendingReviews?.count !== pendingReviews?.reservationData?.length;

	return (
		<>
			{loading && <Loader type="text" />}

			{!loading && (!pendingReviews || pendingReviews.count === 0) && (
				<div className={cx(s.textCenter, s.marginTop)}>
					<img src={noListImage} className={s.mobWidth} alt="No reviews" />
					<div className={s.noListHeading}>
						<FormattedMessage {...messages.noReviewHeading} />
					</div>
					<div className={cx(s.noListSubHeading)}>
						<FormattedMessage {...messages.noReviewSubHeding} />
					</div>
				</div>
			)}

			{!loading && pendingReviews?.reservationData?.length > 0 && (
				<div className={cx(s.panelNolist, s.spaceTop6)}>
					{pendingReviews.reservationData.map((item, index) => {
						const isHost = userId === item.hostId;

						if (item.guestData && item.hostData) {
							return (
								<ul className={cx(s.mediaDisplay, 'listLayoutArbic')} key={index}>
									<li>
										<div className={cx(s.listAvatarGrid)}>
											<div className={cx(s.mediaContainer, s.textCenter, s.pullLeft, 'reviewsId')}>
												<Avatar
													source={isHost ? item.guestData.picture : item.hostData.picture}
													height={48}
													width={48}
													title={isHost ? item.guestData.firstName : item.hostData.firstName}
													className={s.profileAvatar}
													withLink
													linkClassName={cx(s.profileAvatarLink, s.noBackground)}
													profileId={isHost ? item.guestData.profileId : item.hostData.profileId}
												/>
											</div>

											<div className={cx(s.listDeatilsGrid, s.textAlignCenter, 'listingTagCurve whiteBgCurve')}>
												{item.listData ? (
													<p className={s.writeReviewText}>
														<FormattedMessage {...messages.submitReviewFor} />{' '}
														<Link to={`/rooms/${item.listId}`}>
															{item.listTitle || item.listData.title}
														</Link>
													</p>
												) : (
													<p className={s.writeReviewText}>
														<FormattedMessage {...messages.listingNotAvailable} />
													</p>
												)}
												<span className={s.writeReviewIcon}>
													<Link to={`/review/write/${item.id}`}>
														<EditIcon className={cx(s.writeIconCss, 'writeIconRTL')} alt="Write" />
														<FormattedMessage {...messages.writeReview} />
													</Link>
													<Link to={`/users/trips/itinerary/${item.id}`}>
														<ItineraryIcon className={cx(s.reviewIcon, 'reviewIconRTL')} alt="View" />
														<FormattedMessage {...messages.viewLitneray} />
													</Link>
												</span>
											</div>
										</div>
									</li>
								</ul>
							);
						}
						return null;
					})}
				</div>
			)}

			{!loading && showLoadMore && (
				<div className={cx(s.space2, s.textCenter, s.marginTop)}>
					<Button
						className={cx(s.btn, bt.btnPrimary, s.loadMoreBtn)}
						onClick={loadMoreListing}
						disabled={isListLoading}
					>
						<FormattedMessage {...messages.loadMore} />...
					</Button>
				</div>
			)}
		</>
	);
};

WriteReviews.propTypes = {
	data: PropTypes.shape({
		loading: PropTypes.bool,
		pendingReviews: PropTypes.shape({
			count: PropTypes.number,
			reservationData: PropTypes.arrayOf(PropTypes.object),
		}),
	}),
	loadMoreListing: PropTypes.func,
	isListLoading: PropTypes.bool,
};

export default withStyles(s, bt)(WriteReviews);